import React from "react";
import {
  TableCell,
  TableRow,
  Typography
} from "@mui/material";

const ExpenseSummaryInstallments = ({
    state,
    installments
  }) => {
    const totalInstallments = (state?.installment_expenses?.length + 1);

  return (
    <>
      {state?.category !== 'DISCOUNT' &&
      <TableRow>
        <TableCell align={'right'}>
          <Typography>{'Parcelamento'}</Typography>
        </TableCell>
        <TableCell>
          <Typography sx={{ fontWeight: 'bold' }}>{state.installment ? totalInstallments : installments}x</Typography>
        </TableCell>
      </TableRow>
      }
    </>
  )
}

export default ExpenseSummaryInstallments